import { Terminator, VirtualObject } from "@opendaw/lib-std";
import { queueTask } from "@opendaw/lib-dom";
export class PreferencesFacade {
    #terminator = new Terminator();
    #lifecycle = this.#terminator.own(new Terminator());
    #object;
    constructor(settings) {
        this.#object = this.#terminator.own(new VirtualObject(settings));
    }
    setHost(host) {
        this.#lifecycle.terminate();
        host.update(this.#object.data);
        const queueHostUpdate = queueTask(() => host.update(this.#object.data));
        this.#lifecycle.ownAll(host.subscribeAll(() => this.#object.update(host.settings)), this.#object.subscribeAll(queueHostUpdate));
    }
    releaseHost() { this.#lifecycle.terminate(); }
    get settings() { return this.#object.proxy; }
    subscribe(observer, ...path) {
        return this.#object.subscribe(observer, ...path);
    }
    subscribeAll(observer) {
        return this.#object.subscribeAll(observer);
    }
    catchupAndSubscribe(observer, ...path) {
        return this.#object.catchupAndSubscribe(observer, ...path);
    }
    createMutableObservableValue(...path) {
        return this.#object.createMutableObservableValue(...path);
    }
    terminate() { this.#terminator.terminate(); }
}
